import { readFile } from "node:fs/promises";
import { resolve } from "node:path";

import { createServerFn } from "@tanstack/react-start";
import z from "zod";

export const getPublicFile = createServerFn()
  .validator(
    z.object({
      filePath: z.string(),
    }),
  )
  .handler(async (ctx) => {
    const filePath = ctx.data.filePath;

    const normalizedPath = filePath.startsWith("/")
      ? filePath.slice(1)
      : filePath;

    const publicDir =
      process.env.NODE_ENV === "production" ? ".output/public" : "public";
    const absPath = resolve(process.cwd(), publicDir, normalizedPath);

    return readFile(absPath, "utf-8");
  });
